import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Editor from "@tinymce/tinymce-vue";
let wysiwyg = class wysiwyg extends Vue {
    value;
    editorMenu;
    editorHeight;
    editorToolbar;
    editorPlugins;
    shortCuts;
    tinymceAPIKEY = 'h5tkrzqbwlrmk2eq3uzcc7s615kktaz4lgg275ve18rndvzd';
    get initEditor() {
        let language;
        switch (this.$i18n.locale) {
            case 'ru':
                language = 'ru';
                break;
            case 'en':
                language = 'en_US';
                break;
            case 'tr':
                language = 'tr';
                break;
            case 'fi':
                language = 'fi';
                break;
            default:
                language = 'en_US';
        }
        return {
            height: this.editorHeight,
            menubar: this.editorMenu,
            plugins: this.editorPlugins,
            toolbar: this.editorToolbar,
            nonbreaking_force_tab: true,
            language: language,
            pagebreak_split_block: true,
        };
    }
    updateValue(value) {
        this.$emit('input', value);
    }
    handlerFunction(event, editor) {
        console.log(event, editor);
    }
};
__decorate([
    Prop({})
], wysiwyg.prototype, "value", void 0);
__decorate([
    Prop({ default: false })
], wysiwyg.prototype, "editorMenu", void 0);
__decorate([
    Prop({ default: window.innerHeight - 300 })
], wysiwyg.prototype, "editorHeight", void 0);
__decorate([
    Prop({ default: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | fontselect fontsizeselect formatselect | numlist bullist | table pagebreak | removeformat' })
], wysiwyg.prototype, "editorToolbar", void 0);
__decorate([
    Prop({ type: Array, default: () => ['table lists nonbreaking'] })
], wysiwyg.prototype, "editorPlugins", void 0);
__decorate([
    Prop({})
], wysiwyg.prototype, "shortCuts", void 0);
wysiwyg = __decorate([
    Component({
        components: {
            'editor': Editor
        }
    })
], wysiwyg);
export default wysiwyg;
